var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6534 15.6393L9.10872 4.62754C8.64192 2.34005 4.7309 2.34005 4.28483 4.62754L2.13455 15.9016M13.3466 15.6393L14.9045 4.62754C15.3032 2.30907 19.2429 2.12283 19.7284 4.62754L21.8786 15.9016M9.72953 8.79785C10.8889 8.26365 12.9954 8.21576 14.2784 8.79785M8.79489 16.4375C8.85668 17.0581 8.57633 17.6339 8.09415 18.0143M6.61357 19.2429H6.64554M10.0594 11.1769C11.1917 10.7218 12.8517 10.7059 13.9457 11.1769M19.8944 16.4375C19.9562 17.0581 19.6758 17.6339 19.1936 18.0143M17.8038 19.2429H17.8357M6.44444 21.1818C3.98985 21.1818 2 19.097 2 16.9129C2 14.7287 3.98985 12.716 6.44444 12.716C8.89904 12.716 10.8889 14.7287 10.8889 16.9129C10.8889 19.097 8.89904 21.1818 6.44444 21.1818ZM17.5556 21.1818C15.101 21.1818 13.1111 19.097 13.1111 16.9129C13.1111 14.7287 15.101 12.716 17.5556 12.716C20.0102 12.716 22 14.7287 22 16.9129C22 19.097 20.0102 21.1818 17.5556 21.1818Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.e5edca1fd4067fe827ef678be59a2873.svg";
export { ForwardRef as ReactComponent };